// authConfig.js
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: window.location.origin, // Change this to match your setup
  },
};

// getToken
export const getToken = async (instance, accounts) => {
  try {
    const response = await instance.acquireTokenSilent({
      scopes: ["User.Read"],
      account: accounts[0],
    });
    return response.accessToken;
  } catch (error) {
    console.error("Token acquisition failed:", error);
    return null;
  }
};
